/* unplugin-vue-components disabled */import { render } from "./ShareSVG.vue?vue&type=template&id=15f65c1d"
import script from "./ShareSVG.vue?vue&type=script&lang=js"
export * from "./ShareSVG.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__